export const secciones = {
  '1': 'NPS',
  '2': 'Aussagen',
  '3': 'Kontrollfragen',
  '4': 'Demografie',
  '5': 'Offene Fragen',
  '6': '4Alle Praktiken',
  '7': 'Weitere Fragen',
  '8': 'NOM035-Anweisungen',
}
export const preguntas = {
  // '1': 'Einzeloptionsfrage',
  '1': 'Frage mit mehreren Optionen (Optionsfeld)',
  '2': 'Offene Frage',
  '3': 'Erklärung',
  '4': 'Frage mit mehreren Optionen (Optionsfeld)',
  '5': '4Alle Übungen',
  '6': 'Frage mit mehreren Optionen (Check-Schaltfläche)',
  '7': 'NOM035-Anweisung',
  '8': 'Audio',
}
export const abiertas = {
  '1': 'Text öffnen',
  '2': 'Numerischer Text',
}

export const preguntasEspeciales = {
  '1': 'Normale Frage',
  '2': 'Besondere Frage',
}
